import React, { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import ModalAdUnit from '../AdUnit/Modal/Modal';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
const GlobalModalPlacement = ()=>{
    const { isLoggedIn } = useContext(SessionContext);
    const isMobile = useContext(MobileContext);
    if (isMobile) {
        return null;
    }
    // User
    if (isLoggedIn) {
        return /*#__PURE__*/ React.createElement(ModalAdUnit, {
            realEstateId: "97b2237b-f469-4a05-929e-00306ae7da8a"
        });
    }
    // Anon
    return null;
};
GlobalModalPlacement.displayName = 'GlobalModalPlacement';
export default GlobalModalPlacement;
